import React from 'react';
import {
	BarChart as Chart,
	Bar,
	XAxis,
	CartesianGrid,
	Cell,
	LabelList, ResponsiveContainer
} from 'recharts';

import './BarChart.scss';

const COLORS = ['#323232', '#d52b1e'];

export const BarChart = function({ data }) {

	const last = data[data.length - 1];
	last.labelFormatted = last.Value;

	const renderCustomizedLabel = (props) => {

		const { x, y, width, value } = props;

		return (
			<svg>
				<text
					x={x + width / 2}
					y={y - 15}
					fill="black"
					textAnchor="middle"
					dominantBaseline="middle"
					className="value"
					style={{opacity: 0}}
				>
					<animate attributeType="CSS" attributeName="opacity" from="0" to="1" dur="1s" fill="freeze"/>
					{ value ? `${value}+` : ''}
				</text>
			</svg>
		);
	};

	return (
		<ResponsiveContainer width='100%' height='100%'>
			<Chart
				data={data}
				margin={{
					top: 50,
					right: 30,
					left: 30,
					bottom: 30
				}}
				barSize={30}
				className='bar-chart'
			>
				<CartesianGrid strokeDasharray='0' strokeWidth={0.5} vertical={false} />
				<XAxis dataKey='Label' axisLine={{ strokeWidth: 0.5 }} tickLine={false} />
				<Bar
					dataKey='Value'
					animationDuration={2000}
					animationBegin={2000}
				>
					{data.map((entry, index) => (
						<Cell
							stroke=''
							strokeWidth={0}
							fill={index === data.length - 1 ? COLORS[1] : COLORS[0]}
							key={`cell-${index}`}
						/>
					))}
					<LabelList dataKey='labelFormatted' content={renderCustomizedLabel}/>
				</Bar>
			</Chart>
		</ResponsiveContainer>
	);
};
